import React, { useEffect, useState } from 'react'
import propTypes from 'prop-types'
import Button from 'components/controls/button'
import { localizedTranslate } from 'assets/localization'
import { connect } from 'react-redux'
import questionTypeComponents from 'containers/schedulerQuestion/question-types'
import Comment from 'components/comment'
import QuestionText from 'containers/schedulerQuestion/question-text'
import 'less/schedule-question.less'
import { axiosInstance } from 'network/apis'
import {supportedLanguages} from '../../src/shared/helpers/translations.js'
import * as QueryString from "query-string"
import { Spinner } from '@blueprintjs/core'
import { localizedDateFormatter, getLocalTimeZone, guessTimeZone } from 'assets/localization'
import ErrorBar from 'components/error-bar'
import moment from 'moment'
import { timezoneAbbreviationLabel } from 'shared/helpers/user'
import { showOsTerminationPages } from 'shared/helpers/functional.js'
import loginIcon from 'assets/icons/login-lock.png'

const colorBar = () => (
  <div>
    <div className="color-bar"></div>
    <div className="color-bar-2"></div>
  </div>
)

const colorBarFooter = () => (
  <div className="color-bar-footer">
  </div>
)

function mapStateToProps(state) {
  //If Language is not supported we will choose en by default and later we will redirect to error
  let respLanguage = state && state.scheduler && state.scheduler.language && supportedLanguages.includes(state.scheduler.language) ? state.scheduler.language : "en-us"
  return {
    t: localizedTranslate(respLanguage, state.translations[respLanguage] ? state.translations[respLanguage] : state.translations.en_us),
    formatDate: localizedDateFormatter(respLanguage),
  }
}
const Question = propsS => {
const responderLanguage = QueryString.parse(propsS.location.search).ConfLang ? QueryString.parse(propsS.location.search).ConfLang.toLowerCase() : "en_us"
let m = propsS.t('select.time.for.interview')

  const question = {
    "title": "Schedule",
    "question": propsS.t('select.time.for.interview'),
    "questionText": propsS.t('select.time.for.interview'),
    "typeId": 13
  }

  const [selectedTimeSlot, setSelectedTimeSlot] = useState(-1)
  const [selectedTimeSlotDetails, setSelectedTimeSlotDetails] = useState({})
  const [commentText, setCommentText] = useState('')
  const surveyId = propsS.match.params.surveyId
  const rescheduleToken = propsS.match.params.rescheduleToken // in case of a respondent reschedule we will have the rescheduleToken in the url
  const timeSlotId = propsS.match.params.timeSlotId // in case of a respondent reschedule we will have the timeSlotId for the original interview in the url
  const QuestionTypeComponent = question ? questionTypeComponents[question.typeId] : ""
  const hint = 
  <div  dangerouslySetInnerHTML={{
          __html: propsS.t('all.times.are.in', {
            markup: { tagStart: `${timezoneAbbreviationLabel(moment.tz.guess())}` }
          })
        }} />
  
  const [moderatorsAvailability, setModeratorsAvailability] = useState({})
  const [startedAt, setStartedAt] = useState(new Date())
  const [isLoading, setIsLoading] = useState(false)
  const [spinnerLoading, setSpinnerLoading] = useState(true)
  const [availabilitiesFetched, setAvailabilitiesFetched] = useState(false)
  const [errors, setErrors] = useState([])
  const [showTokenExpiredMsg, setShowTokenExpiredMsg] = useState(false)
  const decipherIdentifer = QueryString.parse(propsS.location.search).identifier
  const decipherShghash = QueryString.parse(propsS.location.search).shchash
  const decipherSurveyId = QueryString.parse(propsS.location.search).projectid
  const isTestMode = QueryString.parse(propsS.location.search).isTestMode
  const QSPATH = QueryString.parse(propsS.location.search).QSPATH === "2" ? 2 : 1
  const isUATTesting = true
  const invalidateReschedule = QueryString.parse(propsS.location.search).invalidateReschedule
  
  const [showCompletedMsg, setShowCompletedMsg] = useState(false)
  const [showOverQuotaMsg, setShowOverQuotaMsg] = useState(false)
  const [showErrorMsg, setShowErrorMsg] = useState(false)
  const isReschedule = window.location.href.indexOf("reschedule") != -1
  let rescheduleSuccessfailLink = ""
  let rescheduleFailedLink =""
  if (isUATTesting ) {
    rescheduleSuccessfailLink = `${process.env.REACT_APP_SHG_DOMAIN}/answer/#/123?lang=${responderLanguage}&fromQstool=true&success=1`
    rescheduleFailedLink = `${process.env.REACT_APP_SHG_DOMAIN}/answer/#/123?lang=${responderLanguage}&fromQstool=true&success=0`
  } else {
    rescheduleSuccessfailLink = 'https://healthcare.opinionsite.com/page/268'
    rescheduleFailedLink = 'https://healthcare.opinionsite.com/page/269'
  }
  useEffect(() => {
    if(!supportedLanguages.includes(responderLanguage)){
      if( QSPATH === 1) {
        window.location.href = `http://selfserve.decipherinc.com/survey/selfserve/20dc/${decipherSurveyId}?state=${decipherShghash}&t=4`
      } else {
        setSpinnerLoading(false)
        setShowErrorMsg(true)
      }
    }
  },[responderLanguage])
  async function getAvailabilites() {
    try {
      propsS.setRespondentLanguage(responderLanguage)
      const queryParams = `?respondentIdentifer=${decipherIdentifer}&responderLanguage=${responderLanguage}${rescheduleToken ? `&rescheduleToken=${rescheduleToken}` : ''}`
      const result = await axiosInstance.get(`get_moderators_availability/${QSPATH}/survey/${surveyId}${queryParams}`, { handlerEnabled: true })
        setModeratorsAvailability((result.data))
        setAvailabilitiesFetched(true)
    } catch (e) {
      console.log("an error occured ", e)
      if (e.response.data.customErrorCode == "QUOTA_REACHED" || e.response.data.customErrorCode === "token mismatch" || e.response.data.customErrorCode === "token not found" || e.response.data.customErrorCode === "Respondent not found") {
        if( QSPATH === 1) {
          window.location.href = !isReschedule ? `http://selfserve.decipherinc.com/survey/selfserve/20dc/${decipherSurveyId}?state=${decipherShghash}&t=3` : rescheduleFailedLink
        }
        else {
          if (e.response.data.customErrorCode == "QUOTA_REACHED") {
            setSpinnerLoading(false)
            setShowOverQuotaMsg(true)
          } else {
            setSpinnerLoading(false)
            setShowErrorMsg(true)
          }
        }
      } else if (e.response.status === 404 && QSPATH === 1 ) {
        window.location.href = `http://selfserve.decipherinc.com/survey/selfserve/20dc/${decipherSurveyId}?state=${decipherShghash}&t=4`
      } else if (e.response.status === 404 && QSPATH === 2 ) {
        setSpinnerLoading(false)
        setShowErrorMsg(true)
      }
      else if (e.response.data.customErrorCode === "token expired") {
        setSpinnerLoading(false)
        setShowTokenExpiredMsg(true)
      }
    }

  }

  const onClick = async () => {
    setIsLoading(true)
    const finishedAt = new Date()

    let payload
    let sharedPayload = {
      respondentIdentifer: decipherIdentifer,
      qsPath: QSPATH,
      shgHash: decipherShghash,
      decipherSurveyId: decipherSurveyId,
      comment: commentText,
      surveyId: surveyId,
      startedAt: startedAt,
      finishedAt: finishedAt,
      isReschedule: window.location.href.indexOf("reschedule") != -1,
      rescheduleToken: rescheduleToken,
      timeSlotId: timeSlotId,
      userTimeZone: guessTimeZone(),
      timeZoneAbbr: timezoneAbbreviationLabel(guessTimeZone()),
      responderLanguage: responderLanguage,
      isUATTesting : isUATTesting
    }
    if (invalidateReschedule && (invalidateReschedule === "true" || invalidateReschedule === true)) {
      sharedPayload = {
        ...sharedPayload,
        invalidateReschedule: true
      }
    }
    if (selectedTimeSlot !== -2) {
      payload = {
        ...sharedPayload,
        slot: { ...selectedTimeSlotDetails }

      }
    } else {
      if (commentText.length <= 500 && commentText.length > 0) {
        payload = {
          ...sharedPayload
        }
      } else if (commentText.length < 0) {
        setIsLoading(false)
        propsS.showSnackbarMessageError(propsS.t('question.error.specify.availability'))
        propsS.hideSnackbarMessage()
        return;
      }
      else {
        setIsLoading(false)
        propsS.showSnackbarMessageError(propsS.t('question.error.char.exceeded'))
        propsS.hideSnackbarMessage()
        return;
      }
    }
    try {
      if ((!isTestMode || isTestMode == "false") && (!decipherIdentifer || decipherIdentifer === '' || ( QSPATH === 1 && !isReschedule && (!decipherShghash || decipherShghash === '') )|| !decipherSurveyId || decipherSurveyId === '')) {
        payload = {
          ...sharedPayload,
          eventName: "QSToolResponderRedirectionParams",
          error: "Error while passing query params from decipher to QS Tool",
          statusCode: 500
        }
        await axiosInstance.post(`log-front-end-event`, payload, { handlerEnabled: true })
        throw new Error("Error while passing query  params from decipher to QS Tool")
      }
      let result
      if (!rescheduleToken) {
        result = await axiosInstance.post(`interview/schedule`, payload, { handlerEnabled: true })
      } else {
        result = await axiosInstance.post(`interview/respondent_reschedule `, payload, { handlerEnabled: true })
      }
      console.log("result ", result)
      if( QSPATH === 1) {
        window.location.href = !isReschedule ? `http://selfserve.decipherinc.com/survey/selfserve/20dc/${decipherSurveyId}?state=${decipherShghash}&t=1` : rescheduleSuccessfailLink
      } else {
        setShowCompletedMsg(true)
      }
      
    } catch (e) {
      console.log("en error occured ", e)
      if ((e && e.response != undefined && e.response.data) && (e && e.response && e.response.data && e.response.data.customErrorCode == "TIME_SLOT_TAKEN" || e.response.data.customErrorCode == "TIME_SLOT_NOT_WITHIN_BUFFER")) {
        setErrors([propsS.t('question.error.refresh')])
        getAvailabilites()
      } else {
        if( QSPATH === 1) {
          window.location.href = !isReschedule ? `http://selfserve.decipherinc.com/survey/selfserve/20dc/${decipherSurveyId}?state=${decipherShghash}&t=2` : rescheduleFailedLink
        } else {
          setSpinnerLoading(false)
          setShowErrorMsg(true)
        }
      }
    }

    setIsLoading(false)
  }

  useEffect(() => {
    setStartedAt(new Date())
    getAvailabilites()

  }, [])

  useEffect(() => {
    if (((moderatorsAvailability).constructor === Object) && (Object.keys(moderatorsAvailability).length === 0)) {
      setSpinnerLoading(true)
      if (availabilitiesFetched) {
        if(!isReschedule && QSPATH === 1) {
          window.location.href = `http://selfserve.decipherinc.com/survey/selfserve/20dc/${decipherSurveyId}?state=${decipherShghash}&t=3`
        }
        else {
          setSpinnerLoading(false)
          !isReschedule && setShowErrorMsg(true)
        }
      }
    } else {
      setSpinnerLoading(false)
    }


  }, [moderatorsAvailability, availabilitiesFetched])

  useEffect(() => {
    console.log("comment changed! ", commentText)
  }, [commentText])

  useEffect(() => {
    console.log("selected timeslot changed! ", selectedTimeSlot)
  }, [selectedTimeSlot])

  useEffect(() => {
    document.getElementById("app").style.overflowY = "auto"

  }, [question])

  useEffect(() => {
    console.log("selectedTimeSlotDetails ", selectedTimeSlotDetails)

  }, [selectedTimeSlotDetails])

  const completedMsg = <div className='question-msg-container'>
    <div>
      <div className='question-msg-1' dangerouslySetInnerHTML={{
        __html: propsS.t('question.message.completed.1', {
          markup: { tagStart: `<a href='mailto:interviews@opinionsiteanswers.com' />` }
        })
      }} />
      <div className='question-msg-italic'>{propsS.t('question.message.italic')}</div>
    </div>
    <div className='question-msg-2'>{propsS.t('question.message.completed.2')}</div>
    <div className='question-msg-3' dangerouslySetInnerHTML={{
      __html: propsS.t('question.message.completed.3', {
        markup: { tagStart: `<a href='mailto:interviews@opinionsiteanswers.com' />` }
      })
    }} />
  </div>

  const overQuotaMsg = <div className='question-msg-container'>
    <div className='question-msg-1'>{propsS.t('question.message.overquota.1')}</div>
    <div className='question-msg-2 overquota'>{propsS.t('question.message.overquota.2')}</div>
  </div>

const errorMsg = <div className='question-msg-container'>
<div className='question-msg-1' dangerouslySetInnerHTML={{
        __html: propsS.t('question.message.error', {
          markup: { tagStart: `<a href='mailto:interviews@opinionsiteanswers.com' />` }
        })
      }} />
</div>

  const noModeratorAvailableMsg = <div className="no-moderator-container">
    <div className="no-moderator-card">
      <div className="no-moderator-card card-header"></div>
      <div className="no-moderator-card card-body">
        <p><strong>Thank you for participating in this important research.</strong></p>
        <p>
          There are currently no future interview times available with our moderators. Please check back later to schedule your interview.
          <br />
          <br />
          If you are still facing issues or have any concerns, Please reach out to
          <a href="mailto:helpdesk@opinionsite.com"> helpdesk@opinionsite.com</a>.
          More surveys will be available soon.
        </p>
        <button className="no-moderator-card login-btn" onClick={() => window.location.href = `${process.env.REACT_APP_SHG_DOMAIN}/login`}>
           <img src={loginIcon} alt="Home" />
          Login
        </button>
      </div>
    </div>
  </div>

  return (
    <div>
      <div id="page">
        <div id="header">{colorBar()}</div>
        {spinnerLoading ? <Spinner intent="primary" /> :
          !showTokenExpiredMsg ? showCompletedMsg? <div>{completedMsg}</div> : showOverQuotaMsg? <div>{overQuotaMsg}</div> : showErrorMsg? <div>{errorMsg}</div> : Object.keys(moderatorsAvailability).length === 0 && availabilitiesFetched? noModeratorAvailableMsg : (
          <div id="question">
            <div className="question-text-wrap answer-col-wrap" id="question-text-wrapper">
              <div id="question-text" className="answer-col">
                <QuestionText questionText={question.questionText} />
              </div>
            </div>
            <div className="question-form-wrap answer-col-wrap">
              <div className={`question-form answer-col question-type-${question.typeId}`}>
                {hint ?
                  <div className="question-hint">
                    <div className="help">
                      {hint}
                    </div>
                  </div>
                  :
                  undefined
                }

                {(errors.length) ?
                  <div className="question-errors answer-col-wrap">
                    <div className="answer-col">
                      <ErrorBar errors={errors} />
                    </div>
                  </div> : ''
                }

                <QuestionTypeComponent
                  selectedTimeSlot={selectedTimeSlot}
                  setSelectedTimeSlot={setSelectedTimeSlot}
                  t={propsS.t}
                  moderatorsAvailability={moderatorsAvailability}
                  setSelectedTimeSlotDetails={setSelectedTimeSlotDetails}
                  formatDate={propsS.formatDate}
                />

                {selectedTimeSlot == -2 &&
                  <Comment {...propsS}
                    placeholderText={propsS.t('question.text_placeholder')} commentText={commentText} setCommentText={setCommentText} />
                }
                <div className="line-footer-wrapper">
                  <div className="line-footer">
                  </div>
                </div>

                <div className="clearfix submit-container">
                  <Button
                    className="btn-primary pull-right"
                    onClick={onClick}
                    isLoading={isLoading}
                    disabled={selectedTimeSlot === -1 || isLoading}
                  >
                    {propsS.t('scheduler.link.submit')}
                  </Button>
                </div>
              </div>
            </div>
          </div>) :
            <div className='token-expired-msg-container'>
              <div className='token-expired-msg'>{propsS.t('question.error.expired')}</div>
              <div className='reschedule-contact' dangerouslySetInnerHTML={{
                __html: propsS.t('question.contact.reschedule', {
                  markup: { tagStart: `<a href='mailto:interviews@opinionsiteanswers.com' />` }
                })
              }} />
            </div>}
        <div id="footer">
          {colorBarFooter()}
        </div>
      </div>
    </div>
  )
}

const mapDispatch = {
  showSnackbarMessageError: message => ({
    type: 'SHOW_MESSAGE',
    payload: {
      message: message,
    },
  }),
  hideSnackbarMessage: () => ({ type: 'HIDE_MESSAGE' }),
  setRespondentLanguage: language => ({
    type: 'SET_RESPONDENT_LANGUAGE',
    payload: {
      language: language,
    },
  })

}

Question.propTypes = {
  question: propTypes.shape({
    typeId: propTypes.number.isRequired,
    questionText: propTypes.string.isRequired,
  }),

  handleSubmit: propTypes.func.isRequired,
  setAnswerProps: propTypes.func.isRequired,
  setAnswerDetails: propTypes.func.isRequired,
}

export default connect(
  mapStateToProps,
  mapDispatch,
  null
)(Question)